export const VUEX_GRID_ROWS_ADD = 'VUEX_GRID_ROWS_ADD'
export const VUEX_GRID_ROWS_REMOVE = 'VUEX_GRID_ROWS_REMOVE'
export const VUEX_GRID_REQUEST_SNAPSHOT = 'VUEX_GRID_REQUEST_SNAPSHOT'
export const VUEX_GRID_IMPORT_SPREADSHEET_CLOSE = 'VUEX_GRID_IMPORT_SPREADSHEET_CLOSE'
export const VUEX_GRID_LIST_SET_FILTER = 'VUEX_GRID_LIST_SET_FILTER'
